import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useCloseModal } from '../../../components/modals/ModalsContext'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('screens')
  const onClose = useCloseModal()

  return (
    <>
      <Grid justify="space-between">
        <Col flex={1}>
          <Title size="h5" strong color="dark2" noMargin>
            {t('selectWidget')}
          </Title>
        </Col>
        <Col>
          <Icon name="BsX" onClick={onClose} size={1.5} color="dark3" />
        </Col>
      </Grid>

      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
